import { Component, Input, ViewChild, AfterViewInit, ElementRef, HostListener, HostBinding, Renderer2, OnDestroy } from '@angular/core';
import { GlobalEventBusService } from '@nx-fe/services';
import { GlobalEvents } from 'app/core/global-event-constants';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-card-item',
  templateUrl: './card-item.component.html',
  styleUrls: ['./card-item.component.scss']
})
export class CardItemComponent implements AfterViewInit, OnDestroy {
    @Input() note: any;
    @ViewChild('noteDiv', { static: true}) elementNote: ElementRef;
    @ViewChild('showMore', { static: true}) elementShowMore: ElementRef;
    public isShowMore = true;

    private noteContentHeight = 78;
    private ticketActivePanelsSub: Subscription;

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.IsLargeNote();
    }

    ngAfterViewInit(): void {
        this.IsLargeNote();
        this.registerResizeSubscriptions();
    }

    ngOnDestroy() {
        if (this.ticketActivePanelsSub) {
            this.ticketActivePanelsSub.unsubscribe();
        }
    }

    constructor(private globalEventBusService: GlobalEventBusService) {}

    public toggle() {
        this.isShowMore = !this.isShowMore;
    }

    public IsLargeNote(): boolean {
        if (this.elementNote && this.elementNote.nativeElement) {
                return this.elementNote.nativeElement.offsetHeight >= this.noteContentHeight ? true : false;
        }
    }

    private registerResizeSubscriptions() {
        this.ticketActivePanelsSub = this.globalEventBusService.register(GlobalEvents.viewTicketActivePanels, () => setTimeout(() => { this.onResize(); }, 0));
    }
}
